import { useTranslation } from 'react-i18next';

export const useAppTranslate = (namespace = 'common') => {
    const [t] = useTranslation(namespace);

    return {
        t
    };
}
